import { gql } from '@apollo/client'
import React from 'react'

import { templatesClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useTemplateState = () => React.useContext(Context)
export const useTemplate = () => useTemplateState()?.template

const QUERY = gql`
  query Template($id: ID) {
    template(id: $id) {
      id
      name
      content
      enabled
      entity
      description
      checklistId
      placeType
      updatedAt
      insertedAt
    }
  }
`

const TemplateLoader = ({ children, id }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    skip: !id,
    client: templatesClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default TemplateLoader
